export default [
  { text: "product.assistance_type.FACETOFACE", value: "FACETOFACE" },
  { text: "product.assistance_type.ONLINE", value: "ONLINE" },
  { text: "product.assistance_type.MIXED", value: "MIXED" },
];
